<template>
    <div class="header">
        <!-- 头部 -->
        <div class="head" v-if="isLogin">
            <div class="head_top">
                <div class="head_top_left">
                    <a :href="config.special_url" target="_blank">{{ config.welcome_title }}</a>
                </div>
                <div class="head_top_right" style="color:#999;">
                    <span
                        >我的编号：
                        <router-link exact to="/" class="active">{{ profile.id }}</router-link>
                    </span>
                    <span>
                        余额：
                        <router-link to="/recharge" class="pointer active">￥{{ profile.balance }}</router-link>
                        <span @click="onFrozen">[冻结：￥{{ profile.balance_frozen }}]</span>
                    </span>

                    <span>
                        <a @click="onLogout" class="pointer">退出</a>
                    </span>
                </div>
            </div>
        </div>

        <!-- 导航 -->
        <div class="header_nav w" :class="!isLogin ? 'unLogin' : ''">
            <div class="nav_logo" @click="$router.push('/')">
                <img :src="config.logo" :alt="config.site_title" style="width:130px;" class="pointer" />
            </div>
            <div class="nav_right">
                <div class="per_center_right fr">
                    <div class="nav_group">
                        <router-link to="/" class="nav_btn">首页</router-link>
                        <a target="_blank" :href="config.special_url + '/trademark'" class="nav_btn">购买商标</a>
                        <!-- <router-link to="/seller/sale" class="nav_btn">出售网店</router-link> -->
                        <!-- <a href="" class="nav_btn">网店工具</a>
                        <a href="" class="nav_btn">更多服务</a> -->

                        <!-- <router-link class="nav_btn" active-class="nav-active" to="/resource/flow">信息流</router-link> -->

                        <div class="action">
                            <!-- <router-link to="/order" class="item" title="订单中心"> <i class="icon iconfont icon-dingdan"></i></router-link> -->
                            <router-link to="/recharge" class="item" title="充值中心">
                                <i class="icon iconfont icon-yuan"></i> 在线充值
                            </router-link>

                            <a class="item" :href="config.chat_url" target="_blank"> <i class="icon iconfont icon-kefu"></i> 联系客服</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as Cookies from "js-cookie";

    export default {
        props: {
            nav: {
                default: true,
            },
        },
        data() {
            return {
                person: {},
                index: 0,
                show: true,
            };
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
            isLogin() {
                return this.$store.state.auth.isLogin;
            },
            taxonomies() {
                return this.$store.state.taxonomy;
            },
            urlCallback() {
                return escape(document.URL);
            },
        },
        created() {
            if (this.$route.path.split("/")[1] == "resource") {
                this.show = true;
            } else if (this.$route.path.split("/")[1] == "cart") {
                this.show = true;
            } else {
                this.show = false;
            }
        },
        methods: {
            onFrozen() {
                this.$alert(
                    "因为需要开具增值税发票等原因，系统会自动对一部分余额进行冻结，以保证在消费结束后有足够的金额进行开票。冻结金额并不会影响到您账户的最终余额。",
                    "关于冻结金额",
                    {
                        confirmButtonText: "我知道了",
                    }
                );
            },
            onLogout() {
                let loadingInstance = this.$loading({
                    text: "注销中...",
                });

                this.$http
                    .post("/auth/logout", { device: "pc" })
                    .then((response) => {
                        if (response.success) {
                            //Cookies.remove("bearer");
                            window.location.href = "/login";
                        }
                    })
                    .catch()
                    .then(() => {
                        this.$nextTick(() => {
                            loadingInstance.close();
                        });
                    });
            },
        },
    };
</script>

<style scoped lang="less">
    /* 头部 */
    .header {
        margin-bottom: 18px;
        margin-bottom: 24px;
        background: linear-gradient(0deg, #fff, #f5f5fa);
        box-shadow: inset 0px 5px 5px -4px rgba(0, 0, 0, 0.1);
        border-top: 4px solid #ff622b;
        border-bottom: 1px solid #dcdfe6;
        .head_top {
            font-size: 12px !important;
            height: 38px;
            color: #999;
            display: flex;
            justify-content: space-between;
            width: 1220px;
            margin-left: auto;
            margin-right: auto;
            align-items: center;
        }

        .head_top ul {
            /* float: right; */
            margin-right: 48px;
        }

        .head_top ul li {
            float: left;
            /* margin-left: 10px; */
            font-size: 14px;
            line-height: 35px;
        }

        .head_top .tel {
            float: right;
            height: 35px;
            line-height: 40px;
        }

        .head_top_right > span {
            margin-right: 12px;
        }

        .head_top_right > span:last-child {
            margin-right: 0;
        }

        .header_nav {
            /* margin-top: 50px; */
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .header_nav .nav_logo {
            display: flex;
            align-items: center;
        }

        .header_nav .nav_logo img {
            padding-right: 8px;
        }
    }

    /* 导航 */

    .nav_group {
        display: flex;
        justify-content: center;
        .nav_btn {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333333;
            font-size: 14px;
            width: 85px;
            height: 32px;
            margin: 0 4px;
            &:last-child {
                margin-right: 0;
            }
            &:first-child {
                margin-left: 0;
            }
            &:hover,
            &.router-link-exact-active {
                background-color: #ff622b;
                color: #fff;
            }
        }
    }

    /*
 */

    .per_center_right ul {
        width: 496px;
        /* margin-right: 36px; */
    }

    .nav_btn.nav-active {
        background: #ff622b;
        color: #fff;
        border-radius: 2px;
    }

    .per_center_right li {
        font-size: 14px;
        color: #434343;
        float: left;
        /* width: 20%; */
        padding: 15px;
        padding-bottom: 0;

        text-align: center;
        line-height: 57px;
        padding-top: 21px;
    }

    .per_center_right li > a {
        color: #333333;
    }

    .action {
        display: flex;
        align-items: center;
        margin-left: 12px;
        .item {
            margin-right: 18px;
            height: 32px;
            border-radius: 5px;
            padding: 0 12px;
            border: 1px solid #ff622b;
            background-color: #fffbf9;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
            text-align: center;
            font-size: 14px;
            line-height: 30px;
            color:#ff622b;
            &:hover {
                background-color: #ff622b;
                color: #fff;
            }
            &:last-child {
                margin-right: 0;
            }
            .icon {
                font-weight: 700;
            }
        }
    }
</style>
